import {useIntl} from 'react-intl'
import {PageTitle} from '../../../_metronic/layout/core'
import {ErrorState} from '../../dashboard/components/statesAlert/ErrorState'
import {FilterData} from './componente/filter/FilterData'
import {PageOverlayer} from '../../../components/PageOverlayer'
import {SalesByFranchises} from './SalesByFranchises'
import {SalesByFilteredDate} from './SalesByFilteredDate'
import {SalesByProductCategory} from './SalesByProductCategory'
import {ClientRegistrations} from './ClientRegistrations'
import {DistractsPerPeriod} from './DistractsPerPeriod'
import {SalesPerPeriod} from './SalesPerPeriod'
import {TopProducts} from './TopProducts'
import {useDashboard} from '../../../hooks/kpi/useDashboard'

export const Dashboard = () => {
  const intl = useIntl()
  const {
    query: {isLoading, error, refetch},
  } = useDashboard()

  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.DASHBOARD'})}</PageTitle>
      <FilterData />
      {error && <ErrorState error={error} onRetry={refetch} />}
      <div className='row'>
        <div className='col-md-3 col-lg-3 col-xl-3 col-xxl-3 mb-3'>
          <div className='d-flex flex-column h-100 justify-content-between' style={{gap: '1rem'}}>
            <SalesByFilteredDate />
            <SalesByProductCategory className='h-100 mb-0' />
          </div>
        </div>
        <div className='col-md-3 col-lg-3 col-xl-3 col-xxl-3 mb-3'>
          <div className='d-flex flex-column h-100 justify-content-between' style={{gap: '1rem'}}>
            <ClientRegistrations />
            <SalesByFranchises className='h-100 mb-0' />
          </div>
        </div>

        <div className='col-md-6 col-lg-6 col-xl-6 col-xxl-6 mb-3'>
          <SalesPerPeriod className='h-100 w-100' />
        </div>

        <div className='col-md-6 col-lg-6 col-xl-6 col-xxl-6 mb-3'>
          <TopProducts className='h-100 mb-0' />
        </div>
        <div className='col-md-6 col-lg-6 col-xl-6 col-xxl-6 mb-3'>
          <DistractsPerPeriod className='h-100 mb-0' />
        </div>
      </div>
    </>
  )
}
